import { render, staticRenderFns } from "./present-statistic.vue?vue&type=template&id=5fedc6cf&scoped=true&"
import script from "./present-statistic.vue?vue&type=script&lang=js&"
export * from "./present-statistic.vue?vue&type=script&lang=js&"
import style0 from "./present-statistic.vue?vue&type=style&index=0&id=5fedc6cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fedc6cf",
  null
  
)

export default component.exports